/*
  Used to mapping the activeFilters to be queryParamFilters (in Array)
  examples:
  queryParamFilters = [
    "created_on lte 2023-08-29T17:00:00Z",
    "created_on gte 2023-08-29T17:00:00Z",
    "status.name eq 'DRAFT'",
  ]
*/

const queryFiltersMappings = {
  eq: (key, value) => {
    return `${key} eq ${value[0]}`
  },
  gte: (key, value) => {
    return `${key.replace(/:gte/g, '')} gte ${value}`
  },
  lte: (key, value) => {
    return `${key.replace(/:lte/g, '')} lte ${value}`
  },
  in: (key, values) => {
    let formattedValues

    if (
      [
        'shipped_customer.id:in',
        'destination_address.id:in',
        'vehicle_group.id:in',
        'vehicle_type.id:in',
        'box_type.id:in',
        'product_category.id:in',
        'line_order',
      ].includes(key)
    ) {
      formattedValues = values.map((value) => `${value}`)
    } else if (
      [
        'destination_address_category:in',
        'destination_address.province:in',
        'destination_address.city:in',
        'product_category_id:in',
      ].includes(key)
    ) {
      formattedValues = values.map((value) => `'${value}'`)
    } else {
      formattedValues = values.map((value) => `"${value}"`)
    }

    if ([].includes(key)) {
      return `${key.replace(/:in/g, '')} in ${formattedValues.join(' ')}`
    }

    if (
      [
        'shipped_customer.id:in',
        'destination_address.id:in',
        'product_category.id:in',
        'destination_address.province:in',
        'destination_address.city:in',
        'destination_address_category:in',
        'line_order',
      ].includes(key)
    ) {
      return `${key.replace(/:in/g, '')} in (${formattedValues.join(' ')})`
    }

    return `${key.replace(/:in/g, '')} in (${formattedValues.join(', ')})`
  },
}

const filterMappings = {
  'status.name': queryFiltersMappings.eq,
  'created_on:gte': queryFiltersMappings.gte,
  'created_on:lte': queryFiltersMappings.lte,
  'shipped_customer.id:in': queryFiltersMappings.in,
  'destination_address.id:in': queryFiltersMappings.in,

  'vehicle_group.id:in': queryFiltersMappings.in,
  'vehicle_type.id:in': queryFiltersMappings.in,
  'box_type.id:in': queryFiltersMappings.in,

  'box_type.volume_capacity:gte': queryFiltersMappings.gte,
  'box_type.volume_capacity:lte': queryFiltersMappings.lte,
  'box_type.weight_capacity:gte': queryFiltersMappings.gte,
  'box_type.weight_capacity:lte': queryFiltersMappings.lte,

  'load_weight:gte': queryFiltersMappings.gte,
  'load_weight:lte': queryFiltersMappings.lte,
  'load_volume:gte': queryFiltersMappings.gte,
  'load_volume:lte': queryFiltersMappings.lte,

  'destination_address.province:in': queryFiltersMappings.in,
  'destination_address.city:in': queryFiltersMappings.in,

  'expected_delivered_on:gte': queryFiltersMappings.gte,
  'expected_delivered_on:lte': queryFiltersMappings.lte,

  'product_category.id:in': queryFiltersMappings.in,
  'product_category_id:in': queryFiltersMappings.in,

  'destination_address_category:in': queryFiltersMappings.in,
  line_order: queryFiltersMappings.in,
}

export default filterMappings
